export default "__VITE_ASSET__BGa5t9o6__"